import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  min-height: 500px;
  background-color: #000000;
  padding: 2rem;
  color: #f0f0f0;
  font-family: 'Lato', sans-serif;
`;

export const Content = styled.div`
  max-width: 400px;
  width: 100%;
  text-align: left;
  font-size: 1.3rem;
`;

export const Greeting = styled.h1`
  font-size: 1.4rem;
  font-weight: 600;
  color: #f0f0f0;
  margin: 0 0 1rem 0;
  text-transform: capitalize;
`;

export const Description = styled.p`
  line-height: 1.5;
  color: #f0f0f0;
  margin: 0 0 1rem 0;
`;

export const WarningText = styled.span`
  color: #ff3232;
  font-weight: 500;
`;

export const InfoText = styled.p`
  color: #f0f0f0;
  margin: 0 0 1rem 0;
`;

export const PasswordLabel = styled.label`
  display: block;
  color: #f0f0f0;
  margin: 1.5rem 0 0.5rem 0;
  font-weight: 500;
`;

export const PasswordContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
  margin-top: 1rem;
`;

export const PasswordInput = styled.input`
  flex: 1;
  height: 48px;
  background-color: #000000;
  border: 1px solid #444;
  border-radius: 8px 0 0 8px;
  padding: 0 1rem;
  color: #f0f0f0;
  font-size: 1.5rem;

  &::placeholder {
    color: #888;
  }

  &:focus {
    outline: none;
    border-color: #666;
  }
`;

export const ShowPasswordButton = styled.button`
  width: 48px;
  height: 48px;
  background-color: #4caf50;
  border-radius: 0 8px 8px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #45a049;
  }

  svg {
    color: #2d5a2d;
    width: 20px;
    height: 20px;
  }
`;

export const DeleteButton = styled.button`
  height: 38px;
  background: linear-gradient(4deg, #610000, #ea1010);
  border: 1px solid #c8c8c8a3;
  border-radius: 2em;
  font-family: 'CHIVO';
  font-size: 1em;
  box-shadow: inset 1px 1px 12px black;
  width: 100%;

  &:hover {
    background: linear-gradient(135deg, #a00000 0%, #b00000 100%);
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(139, 0, 0, 0.3);
  }

  &:active {
    transform: translateY(0);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
